import { render } from "./TMainForm.vue?vue&type=template&id=0879f5c8&scoped=true"
import script from "./TMainForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TMainForm.vue?vue&type=script&setup=true&lang=js"

import "./TMainForm.vue?vue&type=style&index=0&id=0879f5c8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0879f5c8"],['__file',"src/pages/scada/forms/TMainForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0879f5c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0879f5c8', __exports__)) {
    console.log('reload')
    api.reload('0879f5c8', __exports__)
  }
  
  module.hot.accept("./TMainForm.vue?vue&type=template&id=0879f5c8&scoped=true", () => {
    console.log('re-render')
    api.rerender('0879f5c8', render)
  })

}


export default __exports__